import { indexItems } from '@/mocks/home';

export default function Index() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-screen-2xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 bg-secondary-100/70 text-secondary-700 text-xs font-medium px-3 py-1 rounded-full mb-4">
            <i className="ri-list-check text-xs"></i>
            <span>作品索引</span>
          </div>
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">
            漫画索引
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            按字母快速查找热门漫画作品
          </p>
        </div>

        <div className="max-w-5xl mx-auto">
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 md:gap-4">
            {indexItems.map((item) => (
              <div
                key={item.title}
                className="flex items-center gap-3 bg-background-50 border border-background-200/70 rounded-lg p-4 hover:border-primary-200/60 hover:bg-primary-50/20 transition-all duration-200 cursor-pointer"
              >
                <div className="w-10 h-10 flex items-center justify-center bg-primary-500 rounded-lg shrink-0">
                  <span className="font-heading text-lg text-background-50">{item.letter}</span>
                </div>
                <div className="min-w-0">
                  <div className="font-medium text-foreground-900 text-sm truncate">{item.title}</div>
                  <span className="text-xs text-foreground-400 whitespace-nowrap">{item.tag}</span>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-8 text-center">
            <div className="inline-flex flex-wrap justify-center gap-1.5">
              {'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('').map((letter) => (
                <span
                  key={letter}
                  className="w-8 h-8 flex items-center justify-center text-xs font-medium text-foreground-400 bg-background-50 border border-background-200/50 rounded cursor-pointer hover:text-primary-500 hover:border-primary-200 transition-colors"
                >
                  {letter}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}